export default function EFPhone(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_1415_8310)">
                <path
                    d="M16.8195 27.2764C17.4088 27.2764 17.8864 26.7987 17.8864 26.2095C17.8864 25.6202 17.4088 25.1426 16.8195 25.1426C16.2303 25.1426 15.7526 25.6202 15.7526 26.2095C15.7526 26.7987 16.2303 27.2764 16.8195 27.2764Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="0.564084"
                ></path>
                <path d="M15.1674 5.95825H18.4716" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
                <path
                    d="M21.8399 3.30054H11.7992C10.2415 3.30054 8.97876 4.56328 8.97876 6.12096V26.8793C8.97876 28.4369 10.2415 29.6997 11.7992 29.6997H21.8399C23.3976 29.6997 24.6603 28.4369 24.6603 26.8793V6.12096C24.6603 4.56328 23.3976 3.30054 21.8399 3.30054Z"
                    stroke="currentColor"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_1415_8310">
                    <rect width="32" height="32" fill="none" transform="translate(0.833313 0.5)"></rect>
                </clipPath>
            </defs>
        </svg>
    );
}
